import { Component, OnInit, Input } from '@angular/core';

import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-clipboard-btn',
  templateUrl: './clipboard-btn.component.html',
  styleUrls: ['./clipboard-btn.component.scss'],
})
export class ClipboardBtnComponent implements OnInit {
  /**
   * Override default content in button
   */
  @Input() btnText: string;

  /**
   * Button CSS classes as string
   */
  @Input() cssClassBtn: string = 'btn btn-outline-info';

  /**
   * Button CSS classes for padding of button as string
   */
  @Input() cssClassPadding: string = 'p-1';

  /**
   * Content to be copied to clipboard
   */
  @Input() content: string;

  /**
   * Error message to be shown if notification is enabled and when content copy to clipboard fails
   */
  @Input() errorNotificationMessage: string;

  /**
   * Enable notification on button click and copy to clipboard
   */
  @Input() notify: boolean = true;

  /**
   * Small button size
   */
  @Input() small: boolean = true;

  /**
   * Success message to be shown if notification is enabled and when content is copied to clipboard
   */
  @Input() successNotificationMessage: string;

  /**
   * Tooltip content
   */
  @Input() title: string;

  /**
   * Inject noty service for creating notification
   * @param {NotyService} public notyService [description]
   */
  constructor(public notyService: NotyService) {}

  ngOnInit() {}
}
